import React, { Fragment } from 'react';
import cln from 'classnames';
import ReactDOM from 'react-dom';
import { FComponent } from 'mytime-common/f-component';
import './monthday-picker.scss';
import { mapKeys } from 'mytime-common/objects';
import { anyAction } from './any-action';
import { paddingLeft } from 'mytime-common/strings';
import { t } from '../../../../locales';

/**
 * Internally use date object
 */
export class MonthdayPicker extends FComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: null,
      choosingMonth: false,
    };

    this.onUnmount(
      anyAction(() => {
        return this.state.value && this.setState({ value: null });
      })
    );
  }

  toggleExpand = e => {
    const { value } = this.state;
    const { value: propsValue, disabled } = this.props;

    if (!value && !disabled) {
      this.setState({
        value: propsValue
          ? {
              month: propsValue.getMonth(),
              date: propsValue.getDate(),
            }
          : {
              month: null,
              date: null,
            },
        choosingMonth: true,
      });
      setTimeout(() => {
        ReactDOM.findDOMNode(this)
          .querySelector('.expand-gross')
          .scrollIntoView();
      }, 0);
    }
    e.stopPropagation();
  };

  render() {
    const { dataProps, value: propsValue } = this.props;
    const { value, choosingMonth } = this.state;

    const renderFull = ({ value, expand }) => (
      <div
        className="monthday-picker"
        {...mapKeys(dataProps, key => 'data-' + key)}
      >
        <div
          className={cln('fake-input', { placeholder: !value })}
          onClick={this.toggleExpand}
        >
          {!value ? (
            <Fragment>
              {t('january')} {renderDate(1)}
            </Fragment>
          ) : (
            <Fragment>
              {value.month != null ? months[value.month].name : '--'}{' '}
              {value.date ? renderDate(value.date) : '--'}
            </Fragment>
          )}
        </div>

        <img alt="calendar" src={require('./calendar.svg')} />

        {expand && (
          <div className="expand-gross">
            <div className="inner">
              {choosingMonth
                ? renderMonths({
                    month: propsValue && propsValue.getMonth(),
                    onChoose: month =>
                      this.setState({
                        value: { ...value, month },
                        choosingMonth: false,
                      }),
                  })
                : renderDates({
                    month: value.month,
                    date: value.date,
                    onChoose: date => this.finish(date),
                  })}
            </div>
          </div>
        )}
      </div>
    );

    return renderFull({
      // eslint-disable-next-line
      value:
        value ||
        (propsValue && {
          month: propsValue.getMonth(),
          date: propsValue.getDate(),
        }),
      expand: !!value,
    });
  }

  finish(date) {
    const { value } = this.state;
    const { onChange } = this.props;
    const resultDate = new Date(new Date().getFullYear(), value.month, date, 0); // -new Date().getTimezoneOffset()
    // console.log(resultDate.toISOString());
    onChange(resultDate);
  }
}

const months = [
  { name: 'january', days: 31 },
  { name: 'february', days: 28 },
  { name: 'march', days: 31 },
  { name: 'april', days: 30 },
  { name: 'may', days: 31 },
  { name: 'june', days: 30 },
  { name: 'july', days: 31 },
  { name: 'august', days: 31 },
  { name: 'september', days: 30 },
  { name: 'october', days: 31 },
  { name: 'november', days: 30 },
  { name: 'december', days: 31 },
];

// console.log(months);

const renderMonths = ({ onChoose, month: selectedMonth }) => (
  <div className="months">
    {months.map((month, i) => (
      <div className="col" key={i}>
        <div
          className={cln('cell', { active: selectedMonth === i })}
          onClick={e => {
            e.stopPropagation();
            return onChoose(i);
          }}
        >
          {t(`months.${month.name}`)}
        </div>
      </div>
    ))}
  </div>
);

const renderDates = ({ onChoose, month, date: currentDate }) => {
  const dateLabels = new Array(months[month].days)
    .fill(0)
    .map((_, i) => paddingLeft(i + 1));
  return (
    <div className="dates">
      {dateLabels.map((date, i) => (
        <div className="col" key={i}>
          <div
            className={cln('cell', { active: currentDate - 1 === i })}
            onClick={() => onChoose(i + 1)}
          >
            {date}
          </div>
        </div>
      ))}
    </div>
  );
};

const renderDate = date => {
  const st = d => {
    if (d > 10 && d < 20) {
      return 'th';
    }
    d = '' + d;
    if (d.endsWith('1')) {
      return 'st';
    }
    if (d.endsWith('2')) {
      return 'nd';
    }
    if (d.endsWith('3')) {
      return 'rd';
    }
    return 'th';
  };

  return (
    <Fragment>
      {paddingLeft(date)}
      <span className="up">{st(date)}</span>
    </Fragment>
  );
};
